import { useRoutes } from "react-router-dom";

import NotFound from "./Site/NotFound";
import Login from "./Login";
import Dashboard from "./Dashboard";
import DashboardPDVs from "./PDVs";
import Relatorios from "./Relatorios";
import Produtos from "./Produtos";
import Evento from "./Evento";
import Grupos from "./Grupos";
import Cardapios from "./Cardapios";

import CryptoJS from "crypto-js";

import "./CSS/App.css";

function App() {
  const isLoggedIn = () => {
    const eventoId = localStorage.getItem("eventoId");
    if (!eventoId) {
      return false;
    } else {
      let codEvento = CryptoJS.AES.decrypt(
        eventoId,
        process.env.REACT_APP_CYPHER_KEY
      );
      // console.log(codEvento.toString(CryptoJS.enc.Utf8));
      return !isNaN(codEvento) && !isNaN(parseFloat(codEvento));
    }
  };

  const routes = useRoutes(
    isLoggedIn()
      ? [
          { path: "/", element: <Dashboard /> },
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/pdvs", element: <DashboardPDVs /> },
          { path: "/relatorios", element: <Relatorios /> },
          { path: "/produtos", element: <Produtos /> },
          { path: "/evento", element: <Evento /> },
          { path: "/grupos", element: <Grupos /> },
          { path: "/cardapios", element: <Cardapios /> },

          { path: "*", element: <NotFound /> }, // Rota para 404
        ]
      : [{ path: "*", element: <Login /> }] // Rota para Login
  );

  return routes;
}

export default App;
